import {ClassName} from '#/utils/utils';
import {ComponentProps, FunctionComponent} from 'react';

type IconButtonProps = {
  IconComponent: FunctionComponent<ClassName>;
  iconClassName: string;
} & ComponentProps<'button'>;

export const IconButton: FunctionComponent<IconButtonProps> = ({IconComponent, iconClassName, ...rest}) => {
  return (
    <button className='hover:opacity-70 align-middle group' {...rest}>
      <IconComponent className={iconClassName} />
    </button>
  );
};
